import {parse, stringify} from 'uuid';

export function parseUUID(uuid: string): string {
    try {
        return stringify(parse(uuid));
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return null;
    }
}
